import React from 'react';
import clsx from 'clsx';
import {
  Table,
  Loader,
} from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const CompactTableHeader = ({
  headerId,
  headerText,
  numberOfColumns,
  className,
  isLoading,
  children,
}) => (
  <Table.Row verticalAlign="middle">
    <Table.HeaderCell colSpan={numberOfColumns} className={clsx('aridhia-compact-table-header', className)}>
      {headerId && (<FormattedMessage id={headerId} />)}
      {headerText}
      {isLoading && <Loader active inline size="tiny" className="aridhia-loader-right" />}
      {children}
    </Table.HeaderCell>
  </Table.Row>
);

export default CompactTableHeader;
